
export type NotificationType = Notification | undefined;

export class Notification {

  constructor(
    public titleKey: string,
    public messageKey: string,
    public level: NotificationLevel,
    public dismissable: boolean,
    public autoDismiss: boolean,
    public id?: number,
    public persistent?: boolean,
    public urgent?: boolean,
    public closeLabel?: string,
    public onDismiss?: (id?: number) => void,
  ) {}
}

export enum NotificationLevel {
  INFO,
  WARNING,
  ERROR,
  SUCCESS
}
